module.exports = __webpack_public_path__ + "static/media/allie14.1913da9b.jpg";